import styled from 'styled-components';

export const Wrapper = styled.div`
  & >:last-child {
    top: 45px;
  }
`;
Wrapper.displayName = 'Wrapper';

export const Value = styled.div`
`;
Value.displayName = 'Value';
